// ─── Styled text field helper ─────────────────────────────────────────────────
export const fieldSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "var(--bg-paper)",
    color: "var(--text-primary)",
    // borderRadius: "10px",
    "& fieldset": { borderColor: "var(--border-color)" },
    "&:hover fieldset": { borderColor: "var(--border-color)" },
    "&.Mui-focused fieldset": { borderColor: "primary.main" },
  },
  "& .MuiInputLabel-root": { color: "var(--text-tertiary)" },
  "& .MuiInputBase-input": { color: "var(--text-primary)" },
};

// ─── fieldSx variant for inside table cells (flat, no border radius, fixed height)
export const tableFieldSx = {
  width: "100%",
  mt: 0,
  mb: 0,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    color: "var(--text-primary)",
    height: "38px",
    borderRadius: 0,
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
  "& .MuiInputBase-input": {
    color: "var(--text-primary)",
    fontSize: 13,
    py: "8px",
  },
};

// inputSx override for AutocompleteWithPagination inside table
export const tableAutocompleteSx = {
  "& .MuiOutlinedInput-root": {
    height: "38px",
    borderRadius: 0,
    backgroundColor: "transparent",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
  "& .MuiInputBase-input": { fontSize: 13 },
  "& .MuiFormLabel-root": { display: "none" },
};

// ─── Helper: compute longest common prefix ────────────────────────────────────
export function getCommonPrefix(skus) {
  if (!skus || skus.length <= 1) return "";
  let prefix = skus[0];
  for (let i = 1; i < skus.length; i++) {
    while (!skus[i].startsWith(prefix)) {
      prefix = prefix.slice(0, -1);
      if (!prefix) return "";
    }
  }
  return prefix.length >= 3 ? prefix : "";
}

// ─── Format variants as compact text ─────────────────────────────────────────
export function formatVariantsText(variants) {
  if (!variants || variants.length === 0) return "—";
  const skus = variants.map((v) => v.sku).filter(Boolean);
  const prefix = getCommonPrefix(skus);
  if (prefix) {
    const parts = variants.map((v) => {
      const suffix = v.sku.slice(prefix.length);
      const price =
        v.price !== "" && v.price != null
          ? `$${Number(v.price).toFixed(2)}`
          : "—";
      return `${suffix || v.sku}-${price}`;
    });
    return `${prefix}(${parts.join(", ")})`;
  }
  return variants
    .map((v) => {
      const price =
        v.price !== "" && v.price != null
          ? `$${Number(v.price).toFixed(2)}`
          : "—";
      return `${v.sku}-${price}`;
    })
    .join(", ");
}

export const FILTER_OPTIONS = [
  { value: "category", label: "Category" },
  { value: "supplier", label: "Supplier" },
  { value: "attribute", label: "Product Attribute" },
];
